import React, {
  forwardRef,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import styles from "./NewFaceListPage.module.css";

// Mui
import {
  Box,
  Checkbox,
  FormControlLabel,
  Skeleton,
  Stack,
  Tooltip,
} from "@mui/material";

// Jds
import {
  ActionButton,
  AvatarV2,
  Button,
  Container,
  DropdownMenuGroup,
  DropdownMenuItem,
  Icon,
  Image,
  InputCheckbox,
  InputFieldV2,
  Notifications,
  Spinner,
  Text,
} from "@jds/core";
import { ReactComponent as RecommendationSparkIcon } from "../../../assets/svg/sparkle.svg";
import { Menu } from "../../../assets/svg/svg";
import JdsModal from "../JdsModal";
import JdsMenu from "../../../components/UI/JdsMenu";

import NameOfFaceForm from "../Form/NameOfFaceForm";
import useApiHttp from "../../../hooks/use-http";
import EmptyState from "../../NoData/EmptyState";
import FsLightbox from "fslightbox-react";
import { useDispatch, useSelector } from "react-redux";
import { uploadPhotosActions } from "../../../store/state-slices/photosUpload";
import {
  addParamsURL,
  downloadFile,
  getFileNameFromDisposition,
} from "../../../util/helper";
import Loader from "../Loader/Loader";
import decryptUrl from "../../../util/img-decryption";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { VirtuosoGrid } from "react-virtuoso";
import { FileUploadContext } from "../../Layout/FileUploadLayout";
import PageLoader from "../Loader/PageLoader";

const gridComponents = {
  List: forwardRef(({ style, children, ...props }, ref) => (
    <div
      ref={ref}
      {...props}
      style={{
        display: "flex",
        flexWrap: "wrap",
        ...style,
      }}>
      {children}
    </div>
  )),
  Item: ({ children, ...props }) => (
    <div
      {...props}
      style={{
        padding: "0.5rem",
        width: "200px",
        display: "flex",
        flex: "none",
        alignContent: "stretch",
        boxSizing: "border-box",
      }}>
      {children}
    </div>
  ),
};

const RECOMMENDATION_PAGE_SIZE = 200;

const getPendingRecommendationCount = (cluster) =>
  (cluster?.recommendations || []).filter(
    (recommendation) =>
      !recommendation?.recommendationStatus ||
      recommendation?.recommendationStatus === "PENDING",
  ).length;

export default function NewFaceListPage({ }) {
  const { id: eventId, cid: clusterId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { handleFileDownloadOP } = useContext(FileUploadContext);
  const {
    username: stateUserName,
    mediaUrl,
    mergeClusterId,
  } = location.state || {};
  const [faceList, setFaceList] = useState([]);
  const [username, setUsername] = useState();
  const [faceCount, setFaceCount] = useState(0);
  const [previewImgArr, setPreviewImgArr] = useState([]);
  const [preview, setPreview] = useState(null);

  const [page, setPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [isDeleteModalClose, setDeleteModalClose] = useState(true);
  const [check, setCheck] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedId, setSelectedId] = useState([]);
  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1,
  });
  const [shareLink, setShareLink] = useState(null);
  const [isEditModalClose, setEditModalClose] = useState(true);
  const [isSharePhotosModalClose, setSharePhotosModalClose] = useState(true);
  const [recommendationCount, setRecommendationCount] = useState(0);

  const { sendRequest: getFaceList, isLoading: isGetFaceListLoading } =
    useApiHttp();
  const { sendRequest: deleteImgReq, isLoading: deleteImgReqing } =
    useApiHttp();
  const { sendRequest: downloadRequest, isLoading: imageIsDownloading } =
    useApiHttp();
  const { sendRequest: getRecommendationList } = useApiHttp();

  const openLightboxOnSlide = (number) => {
    setLightboxController({
      toggler: !lightboxController.toggler,
      slide: number,
    });
  };

  const handleSelectAllChange = (checked) => {
    setSelectAll(checked); // Update checkboxes state
    setCheck((prev) => Array(prev.length).fill(checked));

    // Update selected IDs
    if (checked) {
      const ids = faceList.map((item) => item.mediaId);
      setSelectedId(ids);
    } else {
      setSelectedId([]);
    }
  };

  const handleCheckboxChange = useCallback((checked, index, mediaId) => {
    setCheck((prev) => {
      const newCheck = [...prev];
      newCheck[index] = checked; // Update the checkbox state
      return newCheck; // Return the new array
    });
    if (checked) {
      setSelectedId((pre) => [...pre, mediaId]);
    } else {
      setSelectedId((pre) => pre.filter((item) => item !== mediaId));
      setSelectAll(false);
    }
  }, []);

  const deleteImage = () => {
    const deleteIds = selectedId;

    const formData = new FormData();
    formData.append("eventId", eventId);
    formData.append("mediaIDs", deleteIds);
    deleteImgReq(
      {
        url: `image/delete`,
        method: "DELETE",
        base: "MEDIA",
        formData: true,
        body: formData,
      },
      null,
      (data) => {
        Notifications.toast.success({
          id: "delete-photos",
          title: data.message,
        });
        const fLength = faceList.length;
        setCheck(Array(fLength - deleteIds.length).fill(false));
        setFaceList((pre) =>
          pre.filter((item) => !deleteIds.includes(item.mediaId)),
        );
        setFaceCount((pre) => pre - deleteIds.length);
        setSelectedId([]);
        if (selectAll) {
          if (page == 0) {
            getFaceListHandler(0);
          } else {
            setPage(0);
          }
        }
      },
      (err, data) =>
        Notifications.toast.error({ id: "delete-photos", title: data.message }),
    );
  };
  const getFaceListHandler = (page) => {
    if (clusterId) {
      if (page == 0) {
        setFaceList([]);
        setSelectAll(false);
        setCheck([]);
        setSelectedId([]);
      }
      getFaceList(
        {
          url: `face/cluster-images?eventId=${eventId}&clusterId=${clusterId}&mergeClusterId=${mergeClusterId
            }&page=${page}&size=50`,
          base: "MEDIA",
        },
        null,
        (data) => {
          setFaceCount(data?.count);
          setLastPage(data?.lastPage);
          if (page == 0) {
            setFaceList(data?.data);
            setPreviewImgArr(
              data?.data?.map((item, i) => (
                <div
                  style={{
                    position: "relative",
                    zIndex: 2,
                    opacity: 0,
                    transform: "translateZ(0)",
                    margin: "auto",
                    backfaceVisibility: "hidden",
                    textAlign: "center",
                    height: "auto !important",
                  }}>
                  <PhotoInDiv
                    clusterId={clusterId}
                    item={item}
                    eventId={eventId}
                  />
                </div>
              )),
            );
            setCheck(Array(data?.data.length).fill(false));
          } else {
            setFaceList((prev) => [...prev, ...data?.data]);
            setPreviewImgArr((prev) => [
              ...prev,
              ...data?.data?.map((item) => (
                <div
                  style={{
                    position: "relative",
                    zIndex: 2,
                    opacity: 0,
                    transform: "translateZ(0)",
                    margin: "auto",
                    backfaceVisibility: "hidden",
                    textAlign: "center",
                    height: "auto !important",
                  }}>
                  <PhotoInDiv
                    clusterId={clusterId}
                    item={item}
                    eventId={eventId}
                  />
                </div>
              )),
            ]);
            if (selectAll) {
              setCheck((pre) => [
                ...pre,
                ...Array(data?.data.length).fill(true),
              ]);
              const ids = data?.data?.map((item) => item.mediaId);
              setSelectedId((pre) => [...pre, ...ids]);
            } else {
              setCheck((pre) => [
                ...pre,
                ...Array(data?.data.length).fill(false),
              ]);
            }
          }
        },
      );
    }
  };

  const downloadHandle = (mediaId) => {
    downloadRequest(
      {
        url: `organizer/download`,
        method: "POST",
        base: "MEDIA",
        body: {
          mediaId,
          eventId,
        },
      },
      null,
      (data, res) => {
        const imageUrl = URL.createObjectURL(data);
        const fileName = getFileNameFromDisposition(res);
        downloadFile(imageUrl, fileName);
        Notifications.toast.success({
          id: "download-photos",
          title: "Photo downloaded successfully.",
        });
      },
      (err, data) => {
        Notifications.toast.error({
          id: "download-photos",
          title: data?.message,
        });
      },
    );
  };

  //element observer
  const observerRef = useRef(null);
  const lastElementRef = useCallback(
    (node) => {
      if (isGetFaceListLoading) return;
      if (observerRef.current) observerRef.current.disconnect();
      observerRef.current = new IntersectionObserver((element) => {
        if (element[0].isIntersecting && lastPage > page) {
          setPage((pre) => pre + 1);
        }
      });
      if (node) observerRef.current.observe(node);
    },
    [isGetFaceListLoading, lastPage],
  );

  useEffect(() => {
    if (selectedId.length === faceList.length && selectedId.length !== 0) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [selectedId]);

  useEffect(() => {
    setUsername(stateUserName);
    setPage(0);
  }, [clusterId, stateUserName]);

  useEffect(() => {
    getFaceListHandler(page);
  }, [page, clusterId]);

  useEffect(() => {
    if (!eventId || !clusterId) {
      setRecommendationCount(0);
      return;
    }

    let ignore = false;

    const fetchRecommendationPage = (pageNumber = 0) => {
      getRecommendationList(
        {
          url: `events/${eventId}/recommendation?page=${pageNumber}&size=${RECOMMENDATION_PAGE_SIZE}`,
          method: "GET",
          base: "MEDIA",
        },
        null,
        (data) => {
          if (ignore) {
            return;
          }

          const clusters = data?.data?.clusters || [];
          const currentCluster = clusters.find(
            (cluster) => `${cluster?.targetClusterId}` === `${clusterId}`,
          );

          if (currentCluster || clusters.length < RECOMMENDATION_PAGE_SIZE) {
            setRecommendationCount(getPendingRecommendationCount(currentCluster));
            return;
          }

          fetchRecommendationPage(pageNumber + 1);
        },
        () => {
          if (!ignore) {
            setRecommendationCount(0);
          }
        },
      );
    };

    fetchRecommendationPage();

    return () => {
      ignore = true;
    };
  }, [clusterId, eventId, getRecommendationList]);

  useEffect(() => {
    setPreviewImgArr(
      faceList.map((item, i) => (
        <div
          style={{
            position: "relative",
            zIndex: 2,
            opacity: 0,
            transform: "translateZ(0)",
            margin: "auto",
            backfaceVisibility: "hidden",
            textAlign: "center",
            height: "auto !important",
          }}>
          <PhotoInDiv clusterId={clusterId} item={item} eventId={eventId} />
        </div>
      )),
    );
  }, [faceList]);

  return (
    <>
      <Container
        horizontalAlign="space-between"
        style={{
          marginTop: "-32px",
          position: "sticky",
          top: "72px",
          backgroundColor: "white",
          padding: "32px 16px 16px",
          zIndex: 30,
          width: "calc(100% + 32px)",
          marginLeft: "-16px",
        }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}>
          <div
            style={{
              display: "flex",
              marginBottom: "16px",
              alignItems: "center",
              gap: "12px",
            }}>
            <Icon
              ic={"IcBack"}
              color="primary_60"
              onClick={() => navigate(`/home/events/faces/${eventId}`)}
            />
            <Text text="Faces" appearance="heading-xs" />
          </div>
          {page === 0 && isGetFaceListLoading ? (
            <Skeleton variant="text" sx={{ fontSize: "1rem", width: "100%" }} />
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}>
              <AvatarV2
                size="xtra-large"
                avatarKind={mediaUrl ? "image" : "icon"}
                image={mediaUrl}
                onClick={() => {
                  setPreview(true);
                }}
              />
              <Text
                text={`${username || "Unnamed"} - ${faceCount} ${faceCount > 1 ? "Photos" : "Photo"
                  }`}
                appearance="body-m"
                color="primary-grey-80"
              />
            </div>
          )}
        </div>
        <div
          style={{
            display: "flex",
            gap: "8px",
          }}>
          <ActionButton
            icon={"IcEditPen"}
            label={username ? "Edit Name" : "Add Name"}
            state="dafault"
            onClick={() => {
              setEditModalClose(false);
            }}
            kind="secondary"
          />
          <ActionButton
            icon={"IcShare"}
            label="Share Photos"
            state="dafault"
            onClick={() => {
              setSharePhotosModalClose(false);
              setShareLink(
                `${process.env.REACT_APP_API_DOMAIN}easy-share/?event_id=${eventId}&cluster_id=${clusterId}`,
              );
            }}
            kind="secondary"
          />
        </div>
      </Container>

      {recommendationCount > 0 && (
        <div className={styles.recommendationBanner}>
          <div className={styles.recommendationBannerContent}>
            <div className={styles.recommendationBannerIcon}>
              <RecommendationSparkIcon />
            </div>
            <div className={styles.recommendationBannerText}>
              <Text
                text={`Review ${recommendationCount} new recommendation${recommendationCount > 1 ? "s" : ""
                  } for this person`}
                appearance="body-m-bold"
                color="primary_60"
                className={styles.recommendationBannerTitle}
              />
              <Text
                text="Our AI curator has identified potential matches in your recent event uploads."
                appearance="body-s"
                color="primary_50"
                className={styles.recommendationBannerSubtitle}
              />
            </div>
          </div>
          <button
            type="button"
            className={styles.recommendationBannerButton}
            onClick={() => navigate(`/home/events/recommendation/${eventId}`)}>
            Start Review
          </button>
        </div>
      )}

      {selectedId.length > 0 && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            background: "#f5f5f5",
            padding: "4px 16px",
            borderRadius: "24px",
            "--color-primary-60": "#444746",
            marginBottom: "8px",
          }}>
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}>
            <Box
              sx={{
                "--color-primary-grey-60": "#444746",
                cursor: "pointer",
              }}
              title="Clear selection"
              onClick={() => {
                setSelectedId([]);
                setCheck((pre) => Array(pre.length).fill(false));
              }}>
              <Icon ic={"IcCloseRemove"} color="grey-60" size="m" />
            </Box>
            <ActionButton
              label={`Selected ${selectedId.length}`}
              icon={"IcImage"}
              kind="secondary"
              size="small"
            />

            <ActionButton
              icon={selectAll ? "IcCheckboxOn" : "IcCheckboxIndeterminate"}
              label="Select"
              size="small"
              kind="secondary"
              onClick={() => {
                handleSelectAllChange(!selectAll);
              }}
            />
            <ActionButton
              icon={"IcDownload"}
              label="Download"
              size="small"
              kind="secondary"
              onClick={() => {
                if (selectedId.length > 1) {
                  handleFileDownloadOP(selectedId, eventId);
                }
                if (selectedId.length == 1) {
                  downloadHandle(...selectedId);
                }
              }}
            />
            <JdsMenu
              trigger={{
                component: MenuButton,
                componentProps: {
                  style: {
                    marginTop: "3px",
                  },
                },
              }}>
              <DropdownMenuGroup hideBottomDivider>
                <DropdownMenuItem
                  prefix={"IcTrash"}
                  label="Delete"
                  value="delete"
                  onClick={() => {
                    setDeleteModalClose(false);
                  }}
                />

                {/* <DropdownMenuItem prefix={"IcShare"} label="Share" value="share" /> */}
              </DropdownMenuGroup>
            </JdsMenu>
          </div>
          <div>
            <Tooltip
              title="You can delete up to 50 photos at a time from an album"
              placement="bottom"
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#fff", // Custom background
                    fontSize: "16px", // Font size
                    padding: "2px 6px",
                    borderRadius: "4px",
                    fontWeight: "700",
                    color: "#444746",
                  },
                },
              }}>
              <Box
                sx={{
                  "--color-primary-grey-60": "#444746",
                }}>
                <Icon ic={"IcInfo"} color="grey-60" size="m" />
              </Box>
            </Tooltip>
          </div>
        </div>
      )}
      {faceList.length !== 0 && (
        <VirtuosoGrid
          style={{
            height:
              selectedId.length > 0
                ? "calc(100vh - 306px)"
                : "calc(100vh - 250px)",
          }}
          className="custom-scrollbar"
          data={faceList}
          components={gridComponents}
          itemContent={(i, photo) => (
            <PhotoCard
              photo={photo}
              openLightboxOnSlide={openLightboxOnSlide}
              lastElementRef={i + 1 === faceList.length ? lastElementRef : null}
              index={i}
              check={check[i]}
              handleCheckboxChange={handleCheckboxChange}
            />
          )}
        />
      )}
      {isGetFaceListLoading && page !== 0 && (
        <Loader size="small" containerProps={{ style: { height: "100%" } }} />
      )}
      {faceList.length === 0 && !isGetFaceListLoading && (
        <Container fullWidth horizontalAlign="center">
          <EmptyState title="No faces found." action={false} />
        </Container>
      )}
      {page === 0 && isGetFaceListLoading && (
        <Container
          fullWidth
          horizontalAlign="center"
          verticalAlign="center"
          style={{ minHeight: "220px" }}>
          <Spinner kind="primary" label="Loading..." size="large" />
        </Container>
      )}
      {deleteImgReqing && (
        <PageLoader
          open={deleteImgReqing}
          label={deleteImgReqing && "Please wait for a while..."}
        />
      )}
      <JdsModal
        size="m"
        kind="custom"
        close={isDeleteModalClose}
        onClose={() => {
          setDeleteModalClose(true);
        }}
        headerProps={{ divider: "false" }}>
        <div>
          <Stack gap={0.5}>
            <Text
              text={
                selectedId.length > 50
                  ? `You can delete a maximum of 50 images at a time.`
                  : `You have selected ${selectedId.length} image(s) to delete.`
              }
              appearance="heading_xs"
            />
            <Text
              text={
                selectedId.length > 50
                  ? `Deselect some images to continue.`
                  : `These items will get permanently deleted from PhotoShare.`
              }
              appearance="body_s"
              color="primary-grey-80"
            />
          </Stack>
          <Stack
            direction={"row"}
            justifyContent={"end"}
            gap={"12px"}
            mt={"8px"}>
            {selectedId.length > 50 ? (
              <ActionButton
                label="Ok"
                kind="primary"
                size="medium"
                onClick={() => {
                  setDeleteModalClose(true);
                }}
                appearance=""
              />
            ) : (
              <>
                {" "}
                <ActionButton
                  label="Cancel"
                  kind="secondary"
                  size="medium"
                  onClick={() => {
                    setDeleteModalClose(true);
                  }}
                  appearance=""
                />
                <ActionButton
                  label="Delete"
                  kind="primary"
                  size="medium"
                  onClick={() => {
                    deleteImage();
                    setDeleteModalClose(true);
                  }}
                  appearance=""
                  state={deleteImgReqing ? "loading" : "normal"}
                />
              </>
            )}
          </Stack>
        </div>
      </JdsModal>

      {/* NameOfFace form Modal */}
      <JdsModal
        header="Name of the Face"
        size="m"
        close={isEditModalClose}
        onClose={() => {
          setEditModalClose(true);
        }}>
        {!isEditModalClose && (
          <NameOfFaceForm
            data={{
              clusterId,
              username,
              mediaUrl,
            }}
            isSuccess={(bool, name, id) => {
              setUsername(name);
            }}
          />
        )}
      </JdsModal>

      {/* Share form Modal */}
      <JdsModal
        header="Share Link"
        // kind="informational"
        size="m"
        close={isSharePhotosModalClose}
        onClose={() => {
          setSharePhotosModalClose(true);
        }}>
        {!isSharePhotosModalClose && (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <Box
              sx={{
                "& .j-JDSInputFieldV2-input-container": { height: "unset" },
                "& .j-JDSIcon-container": { padding: "24px", borderRadius: 0 },
                "& .j-JDSIcon-container:nth-child(1)": {
                  paddingLeft: "12px",
                  borderRight: "1px solid var(--color-primary-grey-60)",
                },
                "& .j-JDSIcon-container:nth-child(3)": {
                  paddingRight: "12px",
                  borderLeft: "1px solid var(--color-primary-grey-60)",
                },
                "& .j-JDSIcon-container:nth-child(1) .icon-atom.j-JDSIcon-icon":
                {
                  color: "var(--color-primary-60)",
                },
                "& .j-JDSIcon-container:nth-child(3) .icon-atom.j-JDSIcon-icon":
                {
                  // color: "var(--color-feedback-error-50)",
                },
              }}
            >
              <InputFieldV2
                prefix={<Icon ic={"IcLink"} />}
                value={shareLink}
                onChange={(e) => {
                  e.preventDefault();
                }}
              />
            </Box>
            <div style={{ display: "flex", justifyContent: "space-evenly" }}>
              <span
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigator.clipboard
                    .writeText(shareLink)
                    .then(() => {
                      Notifications.toast.success({
                        id: "copy-link",
                        title: "Link copied to clipboard",
                      });
                    })
                    .catch((err) => { });
                }}>
                <Icon ic={"IcCopy"} size="xtra-xtra-large" />
                <Text text="Copy Link" />
              </span>
              <span
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => {
                  const message =
                    "Check out the link, it’s got some awesome photos for you!";
                  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
                    message,
                  )}%20${encodeURIComponent(shareLink)}`;
                  window.open(whatsappUrl, "_blank", "noopener,noreferrer");
                }}>
                <Icon ic={"IcWhatsapp"} size="xtra-xtra-large" />
                <Text text="WhatsApp" />
              </span>
              <span
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => {
                  const body = shareLink;
                  const mailToLink = `mailto:?body=${encodeURIComponent(body)}`;
                  window.open(mailToLink, "_blank", "noopener,noreferrer");
                }}>
                <Icon ic={"IcMail"} size="xtra-xtra-large" />
                <Text text="Email" />
              </span>
            </div>
          </div>
        )}
      </JdsModal>

      {previewImgArr.length ? (
        <FsLightbox
          disableLocalStorage={true}
          toggler={lightboxController.toggler}
          sources={previewImgArr}
          slide={lightboxController.slide}
          key={previewImgArr.length}
          onClose={() => { }}
        />
      ) : null}
      {preview && (
        <ImagePreviewModal
          imageUrl={mediaUrl}
          onClose={() => setPreview(null)}
        />
      )}
    </>
  );
}

const MenuButton = (props) => {
  return (
    <ActionButton
      icon={<Menu height="20px" width="20px" />}
      kind="tertiary"
      size="medium"
      {...props}
    />
  );
};

const PhotoCard = ({
  photo = {},
  lastElementRef = null,
  openLightboxOnSlide = () => { },
  index = 0,
  check = false,
  handleCheckboxChange = () => { },
}) => {
  return (
    <div
      className="photos-card"
      key={index}
      style={{
        position: "relative",

        width: "184px",
        height: "184px",
        margin: "8px",
      }}
      onClick={() => {
        openLightboxOnSlide(index + 1);
      }}
      ref={lastElementRef}>
      <div className="frame-container">
        <LazyLoadImage
          alt="face"
          effect="blur"
          src={addParamsURL(decryptUrl(photo?.thumbnailFileSignedPath), {
            size: "s",
            width: 500,
            height: 500,
          })}
          placeholderSrc={addParamsURL(
            decryptUrl(photo?.thumbnailFileSignedPath),
            {
              size: "s",
              width: 500,
              height: 500,
            },
          )}
          style={{
            objectFit: "cover",
            // width: "162px",
            // height: "162px",
            width: "100%",
            height: "100%",
            aspectRatio: 1,
            borderRadius: "24px",
          }}
        />
      </div>
      <div
        className={`card-select-overlay ${check ? "card-select-overlay-view" : ""
          }`}
        onClick={() => {
          // openLightboxOnSlide(index + 1);
        }}>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            marginTop: "15px",
            padding: "0 15px",
          }}>
          <div></div>
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}>
            <InputCheckbox
              checked={check}
              onChange={(e) => {
                handleCheckboxChange(e.target.checked, index, photo?.mediaId);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const PhotoInDiv = ({ item, eventId, clusterId }) => {
  const navigate = useNavigate();
  const eventDetails = useSelector((state) => state.eventDetails);
  const faceNavigation = eventDetails?.eventDetails?.faceNavigation;
  const [scalingFactor, setScalingFactor] = useState(0);
  const [faceDetection, setFaceDetection] = useState(false);
  const [faceDiv, setFaceDiv] = useState([]);
  const { sendRequest: faceDetectionApi, isLoading: isFaceDetectionLoading } =
    useApiHttp();
  const { sendRequest: downloadRequest, isLoading: imageIsDownloading } =
    useApiHttp();

  const faceDetectionHandle = (value) => {
    faceDetectionApi(
      {
        url: `face/show-detected-faces?eventId=${eventId}&mediaId=${value}`,
        method: "GET",
        base: "MEDIA",
      },
      null,
      (data) => {
        setFaceDiv(data?.data);
      },
    );
  };

  const downloadImg = (
    index = 0,
    isMultiple = false,
    fileUrl = "",
    mediaId,
  ) => {
    const formData = new FormData();
    // formData.append("imageUrl", fileUrl);
    formData.append("eventId", eventId);
    formData.append("mediaId", mediaId);
    return new Promise((resolve, reject) => {
      downloadRequest(
        {
          url: `organizer/download`,
          method: "POST",
          base: "MEDIA",
          // formData: true,
          body: {
            eventId,
            mediaId,
          },
        },
        null,
        (data, res) => {
          const imageUrl = URL.createObjectURL(data);
          const fileName = getFileNameFromDisposition(res);
          if (!isMultiple) {
            downloadFile(imageUrl, fileName);
            Notifications?.toast?.success("Image Downloaded");
          } else {
            // dispatch(uploadPhotosActions.setUploadCount(index + 1));
            resolve({ data, res }); // Resolve the Promise with the imageUrl
          }
        },
        (err, data) => {
          Notifications?.toast?.error({
            id: "download-photos-error",
            title: data?.message,
          });
          reject(err);
        },
      );
    });
  };

  const imgRef = useRef(null);
  return (
    <>
      <img
        ref={imgRef}
        // src={item?.reducedFileSignedPath}
        src={decryptUrl(item?.reducedFileSignedPath)}
        style={
          {
            // height: "auto !important",
            // maxHeight: "80vh !important",
            // maxWidth: "50vw",
            // width: "auto !important",
          }
        }
      />

      <div
        style={{
          position: "absolute",
          bottom: "15px",
          width: "100%",
          // minWidth: "500px",
          display: "flex",
          justifyContent: "center",
          gap: "20px",
          marginTop: "10px",
          whiteSpace: "nowrap",
        }}>
        {faceNavigation && (
          <ActionButton
            label={`${faceDetection ? "Hide" : "Show detected faces"}`}
            kind="secondary"
            appearance="contrast"
            onClick={(e) => {
              e.stopPropagation();
              faceDetectionHandle(item?.mediaId);
              const originalWidth = imgRef?.current?.naturalWidth;
              const originalHeight = imgRef?.current?.naturalHeight;
              const scalingFactor = Math.min(
                imgRef?.current?.offsetWidth
                  ? imgRef?.current?.offsetWidth / originalWidth
                  : 0,
                imgRef?.current?.offsetHeight
                  ? imgRef?.current?.offsetHeight / originalHeight
                  : 0,
              );
              setScalingFactor(scalingFactor);

              setFaceDetection((pre) => !pre);
            }}
          />
        )}
        <ActionButton
          kind="secondary"
          icon={"IcDownload"}
          label="Download"
          appearance="contrast"
          state={imageIsDownloading ? "loading" : "normal"}
          onClick={(e) => {
            // e.stopPropagation();

            downloadImg(
              null,
              undefined,
              item?.originalFileSignedPath,
              item?.mediaId,
            );
          }}
        />
      </div>
      {faceDiv?.map((divItem) => (
        <>
          <Tooltip
            title={`${divItem?.username || "Unnamed"}`}
            disablePortal
            PopperProps={{
              modifiers: [
                {
                  name: "zIndex",
                  enabled: true,
                  phase: "write",
                  fn: ({ state }) => {
                    state.styles.popper.zIndex = 1000000001;
                  },
                },
              ],
            }}
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#fff", // Custom background
                  color: "#0c5273ff", // Text color
                  fontSize: "14px", // Font size
                  padding: "2px 6px",
                  borderRadius: "4px",
                  fontWeight: "bold",
                },
              },
            }}>
            <div
              onClick={(e) => {
                e.stopPropagation();
                // window.location.reload();
                // document.body.style.overflow = "";
                // document.documentElement.style.overflow = "";
                // // Remove fslightbox applied styles
                // document.body.classList.remove("fslightbox-open");
                // const fslightbox = document.querySelector(".fslightbox-container");
                // if (fslightbox) {
                //   fslightbox.style.overflow = "";
                // }

                // setLightboxController((pre) => {
                //   return {
                //     ...pre,
                //     toggler: false,
                //     slide: 1,
                //   };
                // });
                if (divItem?.clusterId != clusterId && divItem?.clusterId) {
                  console.log("hello1234", divItem.clusterId, clusterId);

                  const closeBtn = document.querySelector(
                    'div.fslightbox-toolbar-button[title="Close"]',
                  );
                  closeBtn.click();
                  navigate(
                    `/home/events/faces/${eventId}/face-list/${divItem?.clusterId}`,
                    {
                      state: {
                        username: divItem?.username,
                        mediaUrl: divItem?.croppedFaceUrl,
                      },
                    },
                  );
                }
              }}
              key={divItem?.clusterId}
              className="rectangle"
              style={{
                display: faceDetection ? "block" : "none",
                position: "absolute",
                left: divItem?.xcoordinate * scalingFactor,
                top: divItem?.ycoordinate * scalingFactor,
                width: divItem?.imageWidth * scalingFactor,
                height: divItem?.imageHeight * scalingFactor,
                border: `2px solid var(--color-primary-50)`,
                borderRadius: "8px",
                cursor: "pointer",
              }}></div>
          </Tooltip>
        </>
      ))}
    </>
  );
};

const ImagePreviewModal = ({ imageUrl, onClose }) => {
  const handleClickOutside = (e) => {
    if (e.target.classList.contains(styles.overlay)) {
      onClose();
    }
  };

  return (
    <div className={styles.overlay} onClick={handleClickOutside}>
      <div className={styles.modal}>
        <button className={styles.closeButton} onClick={onClose}>
          &times;
        </button>
        <img src={imageUrl} alt="Preview" className={styles.image} />
      </div>
    </div>
  );
};
